<!-- Tag Selector Popup -->
<div class="ticket-tag-selector-popup-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-icon" aria-hidden="true">
      <mat-icon>label</mat-icon>
    </div>
    <div class="header-content">
      <h2 class="dialog-title">Create New Tag</h2>
    </div>
    <button class="close-btn" (click)="onCancel()" type="button" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <div class="dialog-content" [formGroup]="tagForm">

    <!-- Tag Name Input -->
    <div class="form-field">
      <label class="field-label">Tag Name</label>
      <input type="text"
        class="tag-input"
        formControlName="name"
        placeholder="Enter tag name..."
        [attr.aria-label]="'Tag name'"
        maxlength="50">
      @if (tagForm.get('name')?.invalid && tagForm.get('name')?.touched) {
        <div class="field-error">
          @if (tagForm.get('name')?.hasError('required')) {
            <span>Tag name is required</span>
          }
          @if (tagForm.get('name')?.hasError('minlength')) {
            <span>Tag name must be at least 2 characters</span>
          }
        </div>
      }
    </div>

    <!-- Color Picker -->
    <div class="form-field">
      <label class="field-label">Color</label>
      <div class="color-picker">
        @for (color of tagColors; track color) {
          <button type="button"
            class="color-option"
            [class.selected]="selectedColor === color"
            [style.background-color]="color"
            (click)="selectColor(color)"
            [attr.aria-label]="'Select color'">
            @if (selectedColor === color) {
              <mat-icon class="check-icon">check</mat-icon>
            }
          </button>
        }
      </div>
    </div>

    <!-- Tag Preview -->
    <div class="form-field">
      <label class="field-label">Preview</label>
      <div class="tag-preview">
        <span class="preview-tag" [style.background-color]="selectedColor">
          {{ tagForm.get('name')?.value || 'Tag name' }}
        </span>
      </div>
    </div>
  </div>

  <!-- Dialog Footer -->
  <div class="dialog-footer">
    <button class="btn-cancel" (click)="onCancel()">
      <mat-icon>close</mat-icon>
      Cancel
    </button>
    <button class="btn-submit" (click)="onSave()" [disabled]="tagForm.invalid">
      <mat-icon>check_circle</mat-icon>
      Create Tag
    </button>
  </div>
</div>
